import { render } from "./SilentRenew.vue?vue&type=template&id=a3048efa&ts=true&lang=pug"
import script from "./SilentRenew.vue?vue&type=script&lang=ts"
export * from "./SilentRenew.vue?vue&type=script&lang=ts"

import "./SilentRenew.vue?vue&type=style&index=0&id=a3048efa&lang=sass"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__